import { LinkParagraph } from '@nexus/lib-react/dist/core/Link/LinkParagraph';
import styled from '@olxeu-a2b/ui/src/theme/styled';

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  margin-top: -40px;
`;

const PointedList = styled.ul`
  padding-inline-start: 20px;
  margin-block-start: 24px;
  margin-block-end: 24px;
  li:not(:last-of-type) {
    margin-bottom: 20px;
  }
`;

const ButtonContent = styled.span`
  margin: -10px;
  padding: 10px 0;
`;

const LinkButton = styled(LinkParagraph)`
  justify-content: center;
  padding-top: 16px;
`;

export default {
  IconContainer,
  PointedList,
  ButtonContent,
  LinkButton,
};
